export default "__VITE_ASSET__Bl_ZOd8x__"